module.exports = __webpack_public_path__ + "img/sosial@3x.93c3359d.png";